// loadPulse.js
var LoadPulse = pc.createScript('loadPulse');

// initialize code called once per entity
LoadPulse.prototype.initialize = function() {
    this.callTwn();
};

LoadPulse.prototype.callTwn = function() {
    var data = {value: 0};

    this.entity
        .tween(data)
        .to({value: 360}, 1, pc.CubicInOut)
        .on('update', function() {
        this.entity.setLocalEulerAngles(0, 0, data.value);
    })
        .loop(true)
        .start();
    //this.entity.tween(this.entity.getLocalPosition()).to({x:100,y:50,z:0}, 5, pc.Linear).start();
};



// update code called every frame
LoadPulse.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// LoadPulse.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

